export const OTHER_REQUEST_REASON = 'other_requests.other_requests';
export const LEGAL_CONCERNS_REASON = 'other_requests.legal_concerns';
export const GDPR_INFORMATION_REASON = 'my_account_how_to_order.gdpr.information';
